import { SendTestReminderPayload } from '@shared/core/test-reminders'
import { useMutation } from 'react-query'
import { ApiService } from 'src/services/api.service'

export function useSendTestReminder() {
  return useMutation('send-test-event', (params: SendTestReminderPayload) => ApiService.TestReminders.send(params))
}
